// extracted by mini-css-extract-plugin
export var feature = "FeatureCard-module--feature--d9a16";
export var icon = "FeatureCard-module--icon--ca302";